/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentListItem } from './TournamentListItem';
import {
    TournamentListItemFromJSON,
    TournamentListItemFromJSONTyped,
    TournamentListItemToJSON,
    TournamentListItemToJSONTyped,
} from './TournamentListItem';

/**
 * 
 * @export
 * @interface TournamentListResponse
 */
export interface TournamentListResponse {
    /**
     * 
     * @type {Array<TournamentListItem>}
     * @memberof TournamentListResponse
     */
    tournaments?: Array<TournamentListItem>;
}

/**
 * Check if a given object implements the TournamentListResponse interface.
 */
export function instanceOfTournamentListResponse(value: object): value is TournamentListResponse {
    return true;
}

export function TournamentListResponseFromJSON(json: any): TournamentListResponse {
    return TournamentListResponseFromJSONTyped(json, false);
}

export function TournamentListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tournaments': json['tournaments'] == null ? undefined : ((json['tournaments'] as Array<any>).map(TournamentListItemFromJSON)),
    };
}

export function TournamentListResponseToJSON(json: any): TournamentListResponse {
    return TournamentListResponseToJSONTyped(json, false);
}

export function TournamentListResponseToJSONTyped(value?: TournamentListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tournaments': value['tournaments'] == null ? undefined : ((value['tournaments'] as Array<any>).map(TournamentListItemToJSON)),
    };
}

